<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter-">The Hunter from the Woods</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">A Michael Gallatin Novel</p>
<p class="ORIM-Author-Name--Front-Matter-">Robert McCammon</p>
<div class="img_container1"> <img alt="image" src="logo.jpg"/> </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?8ecd9f6e